import { Modal } from 'bootstrap';
import chatElements from './config/chatElements';
import { 
    setChatInitialized, 
    getChatInitialized, 
    saveChatVisibilityState, 
    loadChatVisibilityState,
    toggleChatVisibility
} from './config/chatState';
import { addMessage } from './config/chatUtils';
import { startAskMeFlow } from "./flows/flowAskMe";
import { startSupportFlow } from "./flows/flowContactSupport";
import { startGetStartedFlow } from "./flows/flowGetStarted";
import { startNewsletterFlow } from "./flows/flowJoinNewsletter";
import { scheduleQuestions, startScheduleFlow } from "./flows/flowScheduleCall";

const {
  chatContainer,
  initialBox,
  chatToggle,
  chatClose,
  chatToggleButtons,
  restartChat,
  programName,
} = chatElements;

// Assigns unique session ID
if (!sessionStorage.getItem('chatSessionID')) {
    sessionStorage.setItem('chatSessionID', crypto.randomUUID());
}
const chatSessionID = sessionStorage.getItem('chatSessionID');

const initializeChatbot = () => {

    // Default the chatbot to closed on page load. loadChatVisibilityState()
    // below re-opens it only if the user had it open earlier this session.
    initialBox.style.display = 'none';

    // Checks if the user has closed out of the chatbot
    loadChatVisibilityState();

    // Notes which element visible so the toggle buttons control the correct containeer
    chatToggle.addEventListener('click', toggleChatVisibility);
    chatClose.addEventListener('click', toggleChatVisibility);

    // When user chooses to restart the chat
    restartChat.addEventListener('click', (event) => {
        event.preventDefault();
        addMessage(`CHAT RESTARTED`, 'restartSender', 0);
        initialBox.style.display = 'block';
        chatContainer.style.display = 'none';
        setChatInitialized(false);
    });

    window.startChat = function(option, first = true) {
        initialBox.style.display = 'none';
        chatContainer.style.display = 'flex';
        setChatInitialized(true);
        saveChatVisibilityState();

        if(first) {
            addMessage(`Hello! I'm Benny, Decisely's AI Chat Assistant for ${programName}. How may I help you today?`, 'bot', 0);
        }

        // Available user flows
        switch (option) {
            case 'schedule':
                startScheduleFlow(first);
                break;
            case 'newsletter':
                startNewsletterFlow(first);
                break;
            case 'getstarted':
                startGetStartedFlow(first);
                break;  
            // case 'support':
            //     startSupportFlow(first);
            //     break;  
            // case 'askme':
            //     startAskMeFlow(first);
            //     break;
            default:
                startGetStartedFlow(first);
                break;
        }
    };
}

export default initializeChatbot;
